import React from 'react';
import ExpandedInfoILInner from '../expanded-info-il-inner';
import { BuildingPermitItem } from '../../types';

export const ExpandedInfoIL: React.FC<{ item: BuildingPermitItem }> = ({ item }) => {
  return <ExpandedInfoILInner item={item}/>;
};
